'use client'
import { useState, useEffect } from 'react'
import 'styles/actions.css'

const Table = ({
  headers,
  content,
  totalRecords,
  cols,
  extraClass,
  rows = 5,
  pageDynamically,
  setPageDynamically,
  center
}) => {
  const pagination = { resultsByPage: rows }
  const { resultsByPage } = pagination
  const [pages, setPages] = useState([0])
  const [pageCount, setPageCount] = useState('0-0')
  const currentCount = pageDynamically * resultsByPage - resultsByPage + 1
  const showPagination = totalRecords > resultsByPage

  useEffect(() => {
    const pagesSelect = Array.from(
      {
        length: Math.ceil(totalRecords / resultsByPage)
      },
      (_, i) => ({
        page: i + 1,
        selected: i + 1 === pageDynamically
      })
    )
    setPages(pagesSelect)
    setPageCount(
      `${currentCount > 0 ? currentCount : 0}-${
        parseInt(pageDynamically) === pagesSelect.length
          ? totalRecords
          : pageDynamically * resultsByPage
      }`
    )
  }, [pageDynamically, totalRecords])

  return (
    <>
      <div className="block lg:hidden table-container-sm">
        <div>
          {content?.map((item, idx) => {
            let idxAvoidSpan = 0
            const block = (
              <div key={idx}>
                <div className="bg-blue text-white text-[18px] font-alliance-light rounded-t-md py-4 pl-4">
                  {item.name}
                </div>
                <div className="grid grid-cols-1 text-blue font-alliance-medium text-[15px] mb-10">
                  {Object.keys(item)
                    ?.filter((key) => key !== 'link')
                    .map((key, sidx) => {
                      if (!headers?.[sidx]) {
                        idxAvoidSpan = sidx + 1
                      } else if (idxAvoidSpan) {
                        idxAvoidSpan++
                      }
                      return (
                        <div
                          key={sidx}
                          className={`grid grid-cols-2 lg:grid-cols-${cols} border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md`}
                        >
                          <div className="font-alliance-bold py-2 ml-4">
                            {headers[idxAvoidSpan || sidx]}:
                          </div>
                          <div className="grid py-2 ml-2 mr-2">{item[key]}</div>
                        </div>
                      )
                    })}
                </div>
              </div>
            )
            return item?.link ? (
              <a key={idx} href={item?.link || '#'}>
                {block}
              </a>
            ) : (
              <div>{block}</div>
            )
          })}
        </div>
      </div>
      <div className="hidden lg:block table-container-lg">
        <div
          className={`grid grid-cols-${cols} bg-blue text-white text-[15px] font-alliance-light rounded-t-md py-6 pl-6 ${
            center ? 'text-center' : ''
          }`}
        >
          {headers.map((item, idx) => {
            return <div key={idx}>{item}</div>
          })}
        </div>
        <div>
          {content?.map((item, idx) => {
            const block = (
              <div
                key={idx}
                className={`grid grid-cols-${cols} text-blue font-alliance-medium pl-6 py-6 text-[15px] border-blue border-b border-opacity-10 hover:bg-blue hover:bg-opacity-10 hover:rounded-md ${
                  center ? 'text-center' : ''
                }`}
              >
                {Object.keys(item)
                  ?.filter((key) => key !== 'link')
                  .map((key, sidx) => {
                    return (
                      <div key={sidx} className={extraClass?.[sidx] || ''}>
                        {item[key]}
                      </div>
                    )
                  })}
              </div>
            )
            return item?.link ? (
              <a key={idx} href={item?.link || '#'}>
                {block}
              </a>
            ) : (
              <div>{block}</div>
            )
          })}
        </div>
      </div>

      {showPagination && (
        <div className="flex bg-sec-grey-4 bg-opacity-70 mt-8 lg:mt-16 justify-between lg:h-[72px] lg:pl-8 lg:pr-12 px-4">
          <div className="grid content-center">
            <p className="text-blue font-alliance-medium text-[12px] lg:text-[15px]">
              {`${pageCount} de ${totalRecords}`}
            </p>
          </div>
          <div className="grid content-center">
            <div className="flex">
              <p className="grid content-center text-blue opacity-30 text-[12px] lg:text-[15px] font-alliance-medium mr-2 lg:mr-4">
                Estàs a la página
              </p>
              <select
                className="border-none rounded-md text-[12px] lg:text-[15px] font-alliance-medium mr-3 lg:mr-16 focus:ring-0 my-2 lg:my-0"
                onChange={(e) => {
                  setPageDynamically(e.target.value)
                }}
              >
                {pages.map((item, idx) => (
                  <option key={idx} defaultValue={item.selected}>
                    {item.page}
                  </option>
                ))}
              </select>
              <button
                onClick={() => {
                  if (pageDynamically - 1 > 0) {
                    setPageDynamically(pageDynamically - 1)
                  }
                }}
                className="group grid bg-white content-center px-4 rounded-md mr-1 lg:mr-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
              >
                <div>
                  <img
                    src={`/assets/icons/arrow-mini-left.svg`}
                    alt="left"
                    className="block group-hover:hidden"
                  />
                  <img
                    src={`/assets/icons/arrow-mini-left-white.svg`}
                    alt="left"
                    className="hidden group-hover:block"
                  />
                </div>
              </button>
              <div className="border-l-2 border-blue border-opacity-10 my-4 lg:my-1"></div>
              <button
                onClick={() => {
                  if (pageDynamically + 1 <= pages.length) {
                    setPageDynamically(pageDynamically + 1)
                  }
                }}
                className="group grid bg-white content-center px-4 rounded-md ml-1 lg:ml-3 hover:bg-blue hover:text-white hover:cursor-pointer my-2 lg:my-0"
              >
                <div>
                  <img
                    src={`/assets/icons/arrow-mini-right.svg`}
                    alt="right"
                    className="block group-hover:hidden pointer-events-none"
                  />
                  <img
                    src={`/assets/icons/arrow-mini-right-white.svg`}
                    alt="right"
                    className="hidden group-hover:block pointer-events-none"
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Table
